var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c2c" }, [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "text-xs-center" },
          [
            _c("v-progress-circular", {
              staticClass: "primary--text",
              attrs: { indeterminate: "", size: 100, width: 1 }
            })
          ],
          1
        )
      : _c(
          "div",
          [
            _c(
              "v-card",
              { staticClass: "mb-3" },
              [
                _c(
                  "v-card-text",
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c("v-flex", { attrs: { xs6: "", md3: "" } }, [
                          _c(
                            "div",
                            { staticClass: "ml-4 grey--text text--darken-2" },
                            [
                              _vm._v(
                                _vm._s(_vm._f("cap")(_vm.$t("successfulCalls")))
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "ml-4 headline teal--text" },
                            [_vm._v(_vm._s(_vm.nbCalls))]
                          )
                        ]),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs6: "", md3: "" } }, [
                          _c(
                            "div",
                            { staticClass: "ml-4 grey--text text--darken-2" },
                            [
                              _vm._v(
                                _vm._s(_vm._f("cap")(_vm.$t("missedCalls")))
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "ml-4 headline blue--text" },
                            [_vm._v(_vm._s(_vm.nbMissed))]
                          )
                        ]),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs6: "", md3: "" } }, [
                          _c(
                            "div",
                            { staticClass: "ml-4 grey--text text--darken-2" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("cap")(_vm.$t("totalDurationOfCalls"))
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "ml-4 headline deep-purple--text" },
                            [
                              _vm._v(
                                _vm._s(_vm._f("duration")(_vm.totalDuration))
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs6: "", md3: "" } }, [
                          _c(
                            "div",
                            { staticClass: "ml-4 grey--text text--darken-2" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("cap")(
                                    _vm.$t("averageDurationOfACall")
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "ml-4 headline deep-orange--text" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("duration")(
                                    _vm.totalDuration / _vm.nbCalls
                                  )
                                )
                              )
                            ]
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("highcharts", { attrs: { options: _vm.options } })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-card",
              { staticClass: "mb-3" },
              [
                _c(
                  "v-card-text",
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          {
                            staticClass: "headline",
                            attrs: { xs6: "", sm10: "" }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm._f("cap")(_vm.$t("callsDetails")))
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs6: "", sm2: "" } },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  slot: "activator",
                                  color: "primary",
                                  dark: "",
                                  flat: "",
                                  disabled: _vm.callsDetails.length == 0
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.download()
                                  }
                                },
                                slot: "activator"
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("exportInCsv")) +
                                    "\n              "
                                ),
                                _c(
                                  "v-icon",
                                  { attrs: { color: "primary", right: "" } },
                                  [_vm._v("file_download")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-data-table", {
                      attrs: {
                        headers: _vm.headers,
                        items: _vm.callsDetails,
                        "no-data-text": _vm._f("cap")(_vm.$tc("calls", 0)),
                        "no-results-text": _vm._f("cap")(_vm.$tc("results", 0)),
                        "rows-per-page-items": [
                          10,
                          25,
                          50,
                          { text: _vm.$tc("all", 2), value: -1 }
                        ],
                        "rows-per-page-text": _vm._f("cap")(
                          _vm.$t("callsPerPage")
                        )
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "headerCell",
                          fn: function(props) {
                            return [
                              _c("span", [_vm._v(_vm._s(props.header.text))])
                            ]
                          }
                        },
                        {
                          key: "items",
                          fn: function(props) {
                            return [
                              _c("td", [
                                _vm._v(_vm._s(_vm._f("date")(props.item.date)))
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(props.item.time))]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("duration")(props.item.duration)
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(props.item.appelant))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(props.item.appele))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(props.item.site))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    props.item.duration === "0"
                                      ? _vm.$t("yes")
                                      : _vm.$t("no")
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4066b284", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4066b284","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/C2C.vue
// module id = null
// module chunks = 